import axios from 'axios'

/* eslint-disable */

export function slugify(string) {
    const a =
        'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
    const b =
        'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------'
    const p = new RegExp(a.split('').join('|'), 'g')

    return string
        .toString()
        .toLowerCase()
        .replace(/\s+/g, '-') // Replace spaces with -
        .replace(p, (c) => b.charAt(a.indexOf(c))) // Replace special characters
        .replace(/&/g, '-and-') // Replace & with 'and'
        .replace(/[^\w\-]+/g, '') // Remove all non-word characters
        .replace(/\-\-+/g, '-') // Replace multiple - with single -
        .replace(/^-+/, '') // Trim - from start of text
        .replace(/-+$/, '') // Trim - from end of text
}

export const getProducts = async (pages, queryUrl) => {
    let allData = []
    let morePagesAvailable = true
    let currentPage = 0

    if (!pages || !queryUrl) {
        return null
    }

    for (let i = 0; i < pages; i++) {
        currentPage++
        const result = await axios(`${queryUrl}&page=${currentPage}`)

        allData.push(result.data.products)

        morePagesAvailable = currentPage < pages
    }

    if (allData && allData.length) {
        return allData
    }
}

export function fileNameAndExt(str) {
    var file = str.substr(0, str.lastIndexOf('/'));
    var fileExt = str.split('/').pop()
    return [
        file,
        fileExt.substr(0, fileExt.lastIndexOf('.')),
        fileExt.substr(fileExt.lastIndexOf('.') + 1, fileExt.length),
    ]
}

export const stripJSONComments = (data) => {
    var re = new RegExp('//(.*)', 'g')
    return data.replace(re, '')
}

export const getUniqueListBy = (arr, key) => {
    return [...new Map(arr.map((item) => [item[key], item])).values()]
}

export function isEven(value) {
    if (value % 2 == 0) return true
    else return false
}

export const SIZES = [
    'preemie',
    'newborn',
    '0-3m',
    '0–3m',
    '3-6m',
    '3–6m',
    '0-6m',
    '0–6m',
    '6-9m',
    '6–9m',
    '0-12m',
    '0–12m',
    '9-12m',
    '9–12m',
    '6-12m',
    '6–12m',
    '12-18m',
    '12–18m',
    '12-24m',
    '12–24m',
    '18-24m',
    '18–24m',
    '1T',
    '2T',
    '3T',
    '4T',
    '5T',
    '6T',
    '6/7',
    '8',
    '10',
    'XS',
    'XS/S',
    'S',
    'M',
    'M/L',
    'L',
    'L/XL',
    'XL',
    'Big Kid',
    'Little Kid',
    'Adult',
]

export const FILES_URL = 'https://cdn.shopify.com/s/files/1/2338/2917/files/'
